export const DOCUMENT_GALLERY_ZOOM_STOPS = [1, 1.5, 2, 3] as const;

export function shiftDocumentGalleryZoom(current: number, direction: number): number {
  const index = DOCUMENT_GALLERY_ZOOM_STOPS.findIndex((stop) => stop === current);
  const next = Math.max(0, Math.min(DOCUMENT_GALLERY_ZOOM_STOPS.length - 1, (index < 0 ? 0 : index) + direction));
  return DOCUMENT_GALLERY_ZOOM_STOPS[next] ?? 1;
}
